/**
 * §0.5 requires tabular numerals on every currency and quantity figure. The
 * font is applied by the `.numeric` class in tokens.css; these helpers keep
 * the *values* consistent so columns actually align.
 */
export function formatCurrency(value: string | number | null): string {
  if (value === null || value === '') return '—';
  const n = typeof value === 'string' ? Number(value) : value;
  if (!Number.isFinite(n)) return '—';
  return n.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  });
}

export function formatStatus(status: string): string {
  return status.replace(/_/g, ' ');
}

/** §0.5: percentages are numeric figures too, so they get tabular nums. */
export function formatPercent(value: string | number | null): string {
  if (value === null || value === '') return '—';
  const n = typeof value === 'string' ? Number(value) : value;
  if (!Number.isFinite(n)) return '—';
  return `${Math.round(n)}%`;
}

export function formatDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: '2-digit' });
}
